var React = require('react');

function MenuTriangleAsset (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Polygon_17","data-name":"Polygon 17","d":"M5.768,3A2,2,0,0,1,9.232,3l4.037,7a2,2,0,0,1-1.732,3H3.463A2,2,0,0,1,1.73,10Z","transform":"translate(15 13) rotate(180)","fill":"#333"}));
}

MenuTriangleAsset.defaultProps = {"width":"15","height":"13","viewBox":"0 0 15 13"};

module.exports = MenuTriangleAsset;

MenuTriangleAsset.default = MenuTriangleAsset;
